import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(content-info)/content-info-layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layout/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layout/header/header.tsx");
